import React from "react";
import ArrowRight from "../../assets/svg/ArrowRight";
import useCart from "../../hooks/useCart";
import useCoupon from "../../hooks/useCoupon";

const OrderSummary = ({ onClick }) => {
  const { cartData } = useCart();
  const { couponData } = useCoupon();
  // const subTotal = cartData?.items?.reduce((acc, item) => {
  //   const price = item.compare_at_price || item.price || 0; // fallback to current price
  //   return acc + price * item.quantity;
  // }, 0);

  // // CALCULATE REGULAR PRICE DYNAMICALLY
  // const regularTotal = cartData?.items?.reduce((acc, item) => {
  //   const price = item.price || 0; // fallback to current price
  //   return acc + price * item.quantity;
  // }, 0);

  const subTotal = cartData?.items?.reduce((acc, item) => {
    const isUpsell = item.properties?.upsell_discount === "true";

    if (isUpsell) {
      // upsell item → use regular price for subtotal
      return acc + (item.price || 0) * item.quantity;
    }

    const price = item.compare_at_price || item.price || 0;
    return acc + price * item.quantity;
  }, 0);

  const regularTotal = cartData?.items?.reduce((acc, item) => {
    const isUpsell = item.properties?.upsell_discount === "true";
    const upsellPrice = item.properties?.upsell_price;

    if (isUpsell && upsellPrice) {
      // upsell item → use upsell_price (in rupees, convert to paise)
      return acc + upsellPrice * item.quantity * 100;
    }

    return acc + (item.price || 0) * item.quantity;
  }, 0);

  const formattedSubTotal = (subTotal / 100).toFixed(0);
  const formattedRegularTotal = (regularTotal / 100).toFixed(0);

  return (
    <div
      className="order-summary-inner bg-white cursor-pointer rounded-lg"
      onClick={onClick}
    >
      <div className="flex items-start justify-between p-4 gap-3">
        <div>
          <div className="flex items-center gap-2 flex-wrap">
            <p className="text-[18px] supreme-bold">Order summary</p>
            <p className="text-[14px] general-sans-regular">
              ( {cartData?.item_count}{" "}
              {cartData?.item_count > 1 ? "Items" : "Item"} )
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <div className="flex items-baseline gap-2">
            <p className="text-[16px] supreme-medium line-through text-gray-500">
              ₹
              {couponData?.appliedCoupon?.discountAmount
                ? formattedRegularTotal
                : formattedSubTotal}
            </p>
            <p className="text-[18px] supreme-bold">
              ₹
              {couponData?.appliedCoupon?.discountAmount
                ? (
                    formattedRegularTotal -
                    couponData?.appliedCoupon?.discountAmount
                  ).toFixed(0)
                : formattedRegularTotal}
            </p>
          </div>
          <ArrowRight width={12} height={12} className="fill-gray-500" />
        </div>
      </div>
      {couponData?.applied && couponData?.appliedCoupon?.discountAmount && (
        <div className="mb-4 -mt-[6px] px-4">
          <p className="text-[12px] general-sans-medium text-green-700 [word-spacing:0.15rem]">
            🎉 {couponData?.appliedCoupon?.coupon_name} Offer Applied! You save
            ₹{(couponData?.appliedCoupon?.discountAmount).toFixed(0)}!
          </p>
        </div>
      )}

      {couponData?.applied && couponData?.appliedCoupon?.discountAmount && (
        <div className="coupon-applied-bg overflow-hidden rounded-b-lg">
          <p className="text-center text-[12px] p-2 general-sans-medium text-[#238017]">
            Yay! You’ve saved{" "}
            <span className="text-[14px] supreme-bold text-[#238017]">
              ₹{(couponData?.appliedCoupon?.discountAmount).toFixed(0)}
            </span>{" "}
            so far 🥳
          </p>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
